<template>
    <div>
      <!-- Iterate through the toasts and display them -->
      <Toast
        v-for="(toast, index) in toasts"
        :key="index"
        :message="toast.message"
        :type="toast.type"
      />
    </div>
  </template>
  
  <script>
  import Toast from './Toast.vue';
  
  export default {
    components: {
      Toast
    },
    data() {
      return {
        toasts: []
      };
    },
    methods: {
      addToast(message, type = "success") {
        this.toasts.push({ message, type });
  
        // Automatically remove toast after 5 seconds
        setTimeout(() => {
          this.toasts.shift(); // Remove the first toast from the array
        }, 5000);
      }
    }
  };
  </script>
  